import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// api
import ApiKey from '../api/ApiKey';
import BaseApi from '../api/BaseApi';
import { getCities } from '../employersSide/api/getCities';
import { getSubCategories } from '../employersSide/api/getSubCategories';
// components
import JSSidebar from './JSSidebar';
import Footer from '../element/Footer';
import NavBar from '../element/NavBar';
import SelectReact from '../forms/components/SelectReact';
import AsyncSelectReact from '../forms/components/AsyncSelectReact';
// helpers
import { debounceAsync, logOutIfTokenExpired, resultInfo } from '../helpers';

const JSAddAlert = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation('global');
  const userType = Cookies.get('user_type');
  const tokenKey = Cookies.get('tokenClient');

  const [loading, setLoading] = useState(true);
  const [directories, setDirectories] = useState(null);
  const [subCategories, setSubCategories] = useState(null);
  const [errors, setErrors] = useState({ city: null, country: null, category: null, sub_category: null });
  const [addAlert, setAddAlert] = useState({ city: null, country: null, category: null, sub_category: null });

  const getCitiesOptions = async inputValue => {
    if (!addAlert?.country || inputValue.length < 2) {
      return [];
    }

    try {
      const cities = await getCities(parseInt(addAlert?.country?.value), inputValue);

      if (cities.data.response?.length === 0) {
        throw new Error('No options found');
      }

      const options = cities.data.response.map(city => ({
        value: city.id,
        label: `${city.name}${city.region && `, ${city.region}`}`,
      }));

      return options;
    } catch (error) {
      console.error('Error fetching cities:', error);
      return [];
    }
  };

  const getSubCategoriesOptions = async id => {
    try {
      const subCategories = await getSubCategories(id);

      const options = subCategories.data.response.map(position => ({
        value: position.id,
        label: position.name,
      }));

      setSubCategories(options);
    } catch (error) {
      console.error('Couldn\'t get Sub category data!', error);
    }
  };

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        slug ? BaseApi + `/alerts/edit/${slug}` : BaseApi + '/alerts/add',
        null,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            contentType: 'application/json',
          },
        },
      );

      setLoading(false);

      if (response.data.status === 200) {
        setDirectories(response.data.response.directories);
        slug && setAddAlert(prev => ({
          ...prev,
          city: response.data.response.city,
          country: response.data.response.country,
          category: response.data.response.category,
          sub_category: response.data.response.sub_category,
        }));
        slug && getSubCategoriesOptions(response.data.response.category.value);
      } else if (response.data.status === 400) {
        navigate('/');

        Cookies.remove('fname');
        Cookies.remove('user_id');
        Cookies.remove('user_type');
        Cookies.remove('tokenClient');

        resultInfo('warning', response.data.message, t('searchJobPage.close'));
      } else {
        resultInfo('error', response.data.message, t('searchJobPage.close'));
      }
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      }

      console.error('Cannot get designation list of add alert page', error);
    }
  };

  const handleClick = async e => {
    e.preventDefault();

    try {
      const newErrors = {};

      // if (!addAlert.city || addAlert.city.length === 0) {
      //   newErrors.city = t('jobseekerAddAlert.cityRequired');
      //   window.scrollTo(0, 0);
      // }
      if (!addAlert.country || addAlert.country === '') {
        newErrors.country = t('jobseekerAddAlert.countryRequired');
        window.scrollTo(0, 0);
      }
      if (!addAlert.category || addAlert.category === '') {
        newErrors.category = t('jobseekerAddAlert.categoryRequired');
        window.scrollTo(0, 0);
      }
      // if (!addAlert.sub_category || addAlert.sub_category.length === 0) {
      //   newErrors.sub_category = t('jobseekerAddAlert.subCategoryRequired');
      //   window.scrollTo(0, 0);
      // }

      setErrors(newErrors);

      if (Object.keys(newErrors).length === 0) {
        const confirmationResult = await Swal.fire({
          icon: 'question',
          showCancelButton: true,
          cancelButtonText: t('jobseekerAddAlert.no'),
          confirmButtonText: t('jobseekerAddAlert.yes'),
          text: slug ? t('jobseekerEditAlert.confirmTxt') : t('jobseekerAddAlert.confirmTxt'),
          title: slug ? t('jobseekerEditAlert.confirmTitle') : t('jobseekerAddAlert.confirmTitle'),
        });

        if (confirmationResult.isConfirmed) {
          const response = await axios.post(
            slug ? BaseApi + `/alerts/edit/${slug}` : BaseApi + '/alerts/add',
            addAlert,
            {
              headers: {
                key: ApiKey,
                token: tokenKey,
                contentType: 'application/json',
              },
            },
          );

          if (response.data.status === 200) {
            navigate('/alerts/index');

            resultInfo('success', slug ? t('jobseekerEditAlert.successTxt') : t('jobseekerAddAlert.successTxt'), t('jobseekerAddAlert.close'));
          } else if (response.data.status === 400) {
            navigate('/');

            Cookies.remove('fname');
            Cookies.remove('user_id');
            Cookies.remove('user_type');
            Cookies.remove('tokenClient');

            resultInfo('warning', response.data.message, t('searchJobPage.close'));
          } else {
            resultInfo('error', response.data.message, t('searchJobPage.close'));
          }
        }
      }
    } catch (error) {
      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      } else {
        resultInfo('error', slug ? t('jobseekerEditAlert.failedTxt') : t('jobseekerAddAlert.failedTxt'), t('jobseekerAddAlert.close'));
      }

      console.error(slug ? 'Cannot edit alert!' : 'Cannot add alert!', error);
    }
  };

  const handleChange = (name, selectedOptions) => {
    if (name === 'sub_category' && selectedOptions.length > 6) {
      setErrors(prev => ({
        ...prev,
        sub_category: t('jobseekerAddAlert.subCategoryLimit'),
      }));

      return;
    } else if (name === 'city' && selectedOptions.length > 5) {
      setErrors(prev => ({
        ...prev,
        city: t('jobseekerAddAlert.cityLimit'),
      }));

      return;
    }

    setAddAlert(prev => ({
      ...prev,
      [name]: selectedOptions,
    }));

    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const debouncedGetCitiesOptions = debounceAsync(getCitiesOptions, 500);

  useEffect(() => {
    if (userType === 'recruiter' || !tokenKey) {
      navigate('/user/jobseekerlogin');
    } else {
      getData();

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate, userType]); // eslint-disable-line

  return (
    <>
      <NavBar />
      <div className='container createJob JSEditAlert'>
        <div className='row'>
          <div className='col-lg-3'>
            <JSSidebar />
          </div>
          {
            loading
              ? (
                <div className='loader-container' />
              ) : (
                <div className='col-lg-9 mb-5'>
                  <div className='d-flex mx-3 PageHeader'>
                    <img src='/Images/employerSide/icon9color.png' alt='' />
                    <h3 className='mx-2'>{slug ? t('jobseekerEditAlert.editAlert') : t('jobseekerAddAlert.addAlert')}</h3>
                  </div>
                  <form onSubmit={handleClick}>
                    <div className='mb-5 mt-5 editProfileForm'>
                      <SelectReact
                        touched
                        required
                        isClearable
                        isSearchable
                        name='category'
                        error={errors.category}
                        value={addAlert.category}
                        label={t('jobseekerAddAlert.category')}
                        placeholder={t('jobseekerAddAlert.selectCategory')}
                        noOptionsMessage={() => t('jobseekerAddAlert.noOptionsFound')}
                        options={directories?.categories?.map(i => ({ value: i.id, label: i.name }))}
                        handleChange={selectedOptions => {
                          handleChange('category', selectedOptions);
                          setAddAlert(prev =>({
                            ...prev,
                            sub_category: [],
                          }));
                          getSubCategoriesOptions(selectedOptions?.value);
                        }}
                      />
                      <SelectReact
                        isMulti
                        touched
                        isClearable
                        isSearchable
                        name='sub_category'
                        error={errors.sub_category}
                        value={addAlert.sub_category}
                        options={subCategories?.map(i => (i))}
                        label={t('jobseekerAddAlert.subCategory')}
                        placeholder={t('jobseekerAddAlert.selectSubCategory')}
                        handleChange={selectedOptions => handleChange('sub_category', selectedOptions)}
                        noOptionsMessage={
                          () => addAlert?.category
                            ? t('jobseekerAddAlert.noOptionsFound')
                            : t('jobseekerAddAlert.selectCategoryFirst')
                        }
                      />
                      <SelectReact
                        touched
                        required
                        isClearable
                        isSearchable
                        name='country'
                        error={errors.country}
                        value={addAlert.country}
                        label={t('jobseekerAddAlert.country')}
                        placeholder={t('jobseekerAddAlert.selectCountry')}
                        noOptionsMessage={() => t('jobseekerAddAlert.noOptionsFound')}
                        handleChange={selectedOptions => {
                          handleChange('country', selectedOptions);
                          setAddAlert(prev =>({
                            ...prev,
                            city: [],
                          }));
                        }}
                        options={directories?.countries?.map(i => ({ value: i.id, label: i.name }))}
                      />
                      <AsyncSelectReact
                        isMulti
                        touched
                        isClearable
                        name='city'
                        error={errors.city}
                        value={addAlert.city}
                        label={t('jobseekerAddAlert.city')}
                        loadOptions={debouncedGetCitiesOptions}
                        placeholder={t('jobseekerAddAlert.enterCityName')}
                        loadingMessage={() => t('jobseekerAddAlert.pleaseWait')}
                        handleChange={selectedOptions => handleChange('city', selectedOptions)}
                        noOptionsMessage={({ inputValue }) =>
                          !addAlert.country
                            ? t('jobseekerAddAlert.selectCountryFirst')
                            : inputValue.length >= 2
                              ? t('jobseekerAddAlert.noOptionsFound')
                              : t('jobseekerAddAlert.enterCityName')
                        }
                      />
                    </div>
                    <div className='bottomButtons'>
                      <button
                        type='submit'
                        className='btn btn-primary button1'
                        onClick={handleClick}
                      >
                        {slug ? t('jobseekerEditAlert.updateButton') : t('jobseekerAddAlert.submitButton')}
                      </button>
                      <button
                        type='button'
                        onClick={() => navigate(-1)}
                        className='btn btn-primary button2'
                      >
                        {t('jobseekerEditProfile.cancelButton')}
                      </button>
                    </div>
                  </form>
                </div>
              )
          }
        </div>
      </div>
      <Footer />
    </>
  );
};

export default JSAddAlert;
